import { useAuth } from 'react-oidc-context';

const OIDC_RETURN_URL_KEY = 'oidc_return_url';

export function useLogin(): {
  login: () => void;
} {
  const { signinRedirect } = useAuth();

  function login(): void {
    const returnPath = `${window.location.pathname}${window.location.search}`;
    if (returnPath && returnPath !== '/') {
      sessionStorage.setItem(OIDC_RETURN_URL_KEY, returnPath);
    }
    signinRedirect({
      redirect_uri: window.location.origin,
    });
  }

  return { login };
}

export { OIDC_RETURN_URL_KEY };
